__turbopack_context__.v({
  "cardContainer": "WorkMagneticField-module__uywIeq__cardContainer",
  "cardWrapper": "WorkMagneticField-module__uywIeq__cardWrapper",
  "grid": "WorkMagneticField-module__uywIeq__grid",
  "header": "WorkMagneticField-module__uywIeq__header",
  "mobileViewAll": "WorkMagneticField-module__uywIeq__mobileViewAll",
  "section": "WorkMagneticField-module__uywIeq__section",
  "title": "WorkMagneticField-module__uywIeq__title",
  "viewAllIcon": "WorkMagneticField-module__uywIeq__viewAllIcon",
  "viewAllLink": "WorkMagneticField-module__uywIeq__viewAllLink",
});
